import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

import {ApiFragment} from '../../../record/entities/api-fragment.entity';
import {DottedKey} from '../../../record/entities/metadata-field.entity';
import {RecordType} from '../../../record/entities/metadata.entity';
import {RecordWithQRCode} from '../../entities/print.entity';

@Component({
    standalone: false,
    selector: 'archive-mgmt-print-label',
    templateUrl: './print-label.component.html',
    host: { class: 'dgh-print-paper__label' },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrintLabelComponent {
    readonly RecordType: typeof RecordType = RecordType;
    readonly DottedKey: typeof DottedKey = DottedKey;

    @Input()
    image!: RecordWithQRCode;

    @Output()
    public labelLoaded: EventEmitter<RecordWithQRCode> = new EventEmitter<RecordWithQRCode>();

    imageLoaded(): void {
        this.labelLoaded.emit(this.image);
    }

    get title(): string {
        const record: ApiFragment = this.image.record;
        switch (record.getRecordType()) {
            case RecordType.PackagingUnit:
                return record.getReferenceTitle(RecordType.PackagingType);
            case RecordType.TransportUnit:
                return record.getReferenceTitle(RecordType.TransportType);
            case RecordType.LocationElement:
                return record.getField(DottedKey.LocationReadableId);
            case RecordType.Representation:
                return '';
            default:
                return record.getTitle();
        }
    }

    get canShowMoreInfo(): boolean {
        return RecordType.LocationElement !== this.image.record.getRecordType();
    }

    get showOrganisationName(): boolean {
        return RecordType.PackagingUnit === this.image.record.getRecordType();
    }

    get organisationName(): string {
        const organisationName: string = this.image.record.getField(DottedKey.OrganisationLongName);
        if (organisationName.length > 50) {
            return `${organisationName.substring(0, 50)}...`;
        }
        return organisationName
    }

    get expiryDate(): string {
        return this.image.record.getField(DottedKey.DavExpiryExpectedDate);
    }
}
